/*
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-03-20 23:41:59
 * @LastEditors: Li Yong
 * @LastEditTime: 2022-03-29 13:43:42
 */
export default {
  bind(el, binding) {
    // 获取element-ui定义好的scroll盒子
    const selectwarpDom = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap')
    selectwarpDom.addEventListener('scroll', function () {
      const condition = this.scrollHeight - this.scrollTop <= this.clientHeight + 100
      if (condition) {
        binding.value()
      }
    })
  }
};